import './contact.css';
export default function Contact() {
  return (
    <div className='contactwrapper' id='contact'>
      <div className='contactText'>
        <h1 data-aos='fade-down'>contact</h1>
        <h3 data-aos='fade-up-right'>need a website built? i gotchu 💯 🤝.</h3>
        <h3 data-aos='fade-up-left'>
          send an email at{' '}
          <a href='mailto:miguel.buising1@gmail.com'>
            miguel.buising1@gmail.com
          </a>
        </h3>
      </div>
    </div>
  );
}
